module.exports = __webpack_public_path__ + "img/IEC13728.27393523.png";